import { DistinctAirportResponseDTO, filtersReportDTO, findAllReportResponseDTO, GeneratePdfRequestDTO, ReportCreareRequestDTO, ReportDTO, ReportUpdateDTO } from "./dto";
import { ReportServiceImpl } from "./serviceImpl";

export interface ReportService {
    findAllReport(filters: filtersReportDTO): Promise<findAllReportResponseDTO>
    findByIdReport(id: string): Promise<ReportDTO>
    create(request: ReportCreareRequestDTO): Promise<string>
    delete(id: string): Promise<void>
    updateReport(id: string, request: ReportUpdateDTO): Promise<void>
    refresh(id: string): Promise<string>
    distinctAirports(): Promise<DistinctAirportResponseDTO>
    generatePdf(request: GeneratePdfRequestDTO): Promise<string>
}

export function NewReportService(): ReportService {
    return new ReportServiceImpl();
}
